import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { Upload } from "lucide-react";
import {
    Button, Col, Container, FormGroup, Input, Label,
    Modal, ModalBody, ModalFooter, ModalHeader, Row,
    Spinner
} from "reactstrap";
import Handler from "../../Helpers/Handler";
import { toast } from "react-toastify";
import { reloadWindow } from "../../Helpers/Utils";
import { loadingFalse, loadingTrue } from "../../Reducer/loaderSlice";
import { useDispatch, useSelector } from "react-redux";

const AddItemCard = () => {

    const [formData, setFormData] = useState({ name: "", price: "", unit: null, category: null, subcategory: null, image: null, });
    const [categories, setCategories] = useState([]);
    const [subcategories, setSubcategories] = useState([]);
    const dispatch = useDispatch()
    const loading = useSelector((state) => state?.loading?.loading);
    const [units, setUnits] = useState([]);
    const [preview, setPreview] = useState(null);
    const [modalCategory, setModalCategory] = useState(false);
    const [modalSubCategory, setModalSubCategory] = useState(false);
    const [modalUnit, setModalUnit] = useState(false);
    const [modalCSV, setModalCSV] = useState(false);
    const [newData, setNewData] = useState({ name: "" });
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [csvFile, setCsvFile] = useState(null);
    const [csvPreview, setCsvPreview] = useState([]);
    const fileInputRef = useRef(null);

    const getCategories = async () => {
        const response = await Handler({ method: "get", url: `/categories/categories_list.php` });
        if (response?.success) {
            setCategories(
                response.data.map((c) => ({ value: c.category_id, label: c.name }))
            );
        }
    };

    // const getUnits = async () => {
    //     const response = await Handler({ method: "post", url: `/business/template_fields.php`, data : {business_type_id : 1} });
    //     if (response?.success) {
    //         setCategories( response.data.map((c) => ({ value: c.category_id, label: c.name })) );
    //     }else{
    //         toast.error(response?.message)
    //     }
    // };

    const getSubcategories = async (categoryName) => {
        const response = await Handler({
            method: "get", url: `/categories/sub_categories_list.php?category_name=${categoryName}`
        });

        if (response?.success) {
            setSubcategories(
                response.data.map((s) => ({
                    value: s.subcategory_id,
                    label: s.name
                }))
            );
        }
    };

    const handleImageSelect = (event) => {
        const file = event.target.files[0];
        if (file) {
            if (file.size > 2 * 1024 * 1024) {
                toast.error("Image size must be less than 2MB");
                return;
            }
            setFormData({ ...formData, image: file });
            setPreview(URL.createObjectURL(file));
        }
    };

    const handleCategoryChange = (option) => {
        setFormData({
            ...formData,
            category: option,
            subcategory: null,
        });
        getSubcategories(option.label);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.image)
            return toast.error("Please select image");
        else if (!formData.name)
            return toast.error("Enter product name");
        else if (formData.name.length < 3)
            return toast.error("Product name must be at least 3 characters");
        else if (!formData.price)
            return toast.error("Enter price");
        else if (Number(formData.price) <= 0)
            return toast.error("Enter valid price");
        else if (formData.price.length > 6)
            return toast.error("Price is too long");
        else if (!formData.unit)
            return toast.error("Select a unit");
        else if (!formData.category)
            return toast.error("Select a category");
        else if (!formData.subcategory)
            return toast.error("Select a sub category");
        else if (formData.subcategory.label?.length < 3)
            return toast.error("Sub category must be at least 3 characters");
        const payload = new FormData();
        payload.append("name", formData.name);
        payload.append("price", formData.price);
        payload.append("unit", formData.unit);
        payload.append("category_name", formData.category.label);
        payload.append("subcategory_name", formData.subcategory.label);
        payload.append("image", formData.image);
        dispatch(loadingTrue());
        const response = await Handler({ method: "post", url: `/products/add.php`, data: payload, headers: { "Content-Type": "multipart/form-data" } });
        if (response?.success) {
            dispatch(loadingFalse());
            toast.success(response.message);
            setTimeout(() => reloadWindow(), 1000);
        } else {
            dispatch(loadingTrue());
            toast.error(response?.message);
        }
    };

    const handleCSVFile = (e) => {
        const file = e.target.files[0];
        setCsvFile(file);
        if (file && file.type.includes("csv")) {
            const reader = new FileReader();
            reader.onload = (ev) => {
                const rows = ev.target.result.split("\n").slice(0, 6);
                setCsvPreview(rows);
            };
            reader.readAsText(file);
        } else {
            setCsvPreview([]);
        }
    };

    const uploadCSV = async () => {
        if (!csvFile) return toast.error("Select CSV file");
        const fd = new FormData();
        fd.append("file", csvFile);
        dispatch(loadingTrue())
        const response = await Handler({
            method: "post", url: `/products/import_csv.php`, data: fd, headers: { "Content-Type": "multipart/form-data" }
        });
        if (response?.success) {
            dispatch(loadingFalse())
            toast.success(response.message);
            setModalCSV(false);
        } else {
            dispatch(loadingFalse())
            toast.error(response.message);
        }
    };

    const addCategory = async () => {
        if (!newData.name) return toast.error("Enter Category name");
        else if (newData.name?.length < 3) toast.error('Check Category Name')
        const response = await Handler({ method: "post", url: `/categories/categories.php`, data: { name: newData.name } });
        dispatch(loadingTrue());
        if (response?.success) {
            dispatch(loadingFalse());
            toast.success("Category Added");
            setModalCategory(false);
            getCategories();
        } else { dispatch(loadingTrue()); toast.error(response.message); }
    };

    const addUnit = async () => {
        if (!newData.name) return toast.error("Enter Unit name");

        const response = await Handler({ method: "post", url: `/business/add_fields.php`, data: { business_type_id: 1, field_name: newData.name } });
        dispatch(loadingTrue());
        if (response?.success) {
            dispatch(loadingFalse());
            toast.success("Unit Added Successfully");
            setModalUnit(false);
            getCategories();
        } else { dispatch(loadingFalse()); toast.error(response.message); }
    };

    const addSubCategory = async () => {
        if (!selectedCategory) return toast.error("Select Category");
        if (!newData.name) return toast.error("Enter Sub Category Name");
        else if (newData.name?.length < 3) toast.error('Check Category Name')
        dispatch(loadingTrue());
        const response = await Handler({
            method: "post",
            url: `/categories/sub_categories.php`,
            data: {
                name: newData.name,
                category_id: selectedCategory.value
            }
        });
        if (response?.success) {
            dispatch(loadingFalse());
            toast.success("Sub Category Added");
            setModalSubCategory(false);
        } else { dispatch(loadingFalse()); toast.error(response.message); }
    };

    useEffect(() => {
        getCategories();
        // getUnits()
    }, []);

    return (
        <Container>
            <Row className="py-5 justify-content-center">
                <Col xs={12} md={10}>

                    <div className="d-flex top-btns justify-content-between mb-4">
                        <Button disabled={loading} color="dark" onClick={() => setModalCategory(true)}>Add Category</Button>
                        <Button disabled={loading} color="dark" onClick={() => setModalSubCategory(true)}>Add Sub Category</Button>
                        <a href="/sample.csv" download className="btn btn-dark"> Download Sample CSV </a>
                        <Button disabled={loading} color="dark" onClick={() => setModalCSV(true)}>Import CSV</Button>
                    </div>
                    <div className="add-item-card">
                        <h2 className="category-title text-center mb-4">Add Product</h2>
                        <Row>
                            <Col md={6}>
                                <label>Product Image</label>
                                <div className="upload-section" onClick={() => fileInputRef.current.click()}>
                                    {preview ? (
                                        <img src={preview} alt="preview" className="preview-image" />
                                    ) : (
                                        <div className="upload-placeholder">
                                            <Upload size={40} color="#FE9F43" />
                                            <p>Upload Image</p>
                                            <small>Max 2MB</small>
                                        </div>
                                    )}
                                </div>
                                <input type="file" ref={fileInputRef} hidden accept="image/*" onChange={handleImageSelect} />
                                <FormGroup className="mt-3">
                                    <Label>Name</Label>
                                    <Input
                                        value={formData.name}
                                        onChange={(e) =>
                                            setFormData({ ...formData, name: e.target.value })
                                        }
                                        placeholder="Enter product name"
                                    />
                                </FormGroup>
                            </Col>

                            <Col md={6}>
                                <FormGroup>
                                    <Label>Price</Label>
                                    <Input
                                        value={formData.price}
                                        onChange={(e) => {
                                            if (/^\d*$/.test(e.target.value)) {
                                                setFormData({ ...formData, price: e.target.value });
                                            }
                                        }}
                                        placeholder="Enter price"
                                        maxLength={6}
                                    />
                                </FormGroup>

                                <FormGroup>
                                    <Label>Unit</Label>
                                    <Input
                                        value={formData.unit}
                                        onChange={(e) =>
                                            setFormData({ ...formData, unit: e.target.value })
                                        }
                                        placeholder="Enter Unit Name"
                                    />
                                    {/* <Select
                                        classNamePrefix={'vertical'}
                                        options={units}
                                        value={formData.unit}
                                        onChange={(opt) => setFormData({ ...formData, unit: opt })}
                                        placeholder="Select unit"
                                    /> */}
                                </FormGroup>

                                <FormGroup>
                                    <Label>Category</Label>
                                    <Select
                                        classNamePrefix={'vertical'}
                                        options={categories}
                                        value={formData.category}
                                        onChange={handleCategoryChange}
                                        placeholder="Select category"
                                    />
                                </FormGroup>

                                <FormGroup>
                                    <Label>Sub Category</Label>
                                    <Select
                                        classNamePrefix={'vertical'}
                                        options={subcategories}
                                        value={formData.subcategory}
                                        onChange={(opt) =>
                                            setFormData({ ...formData, subcategory: opt })
                                        }
                                        placeholder="Select sub category"
                                        isDisabled={!formData.category}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Button disabled={loading} onClick={handleSubmit} className="d-flex align-items-center justify-content-center gap-2 submit-btn mt-3">
                            {loading && (
                                <Spinner size="sm" color="light" />
                            )}
                            Add Product
                        </Button>

                        {/* <button className="submit-btn mt-3" onClick={handleSubmit}> Add Product </button> */}
                    </div>
                </Col>
            </Row>

            {/* CATEGORY MODAL */}
            <Modal isOpen={modalCategory} toggle={() => setModalCategory(false)} centered className="custom-modal">
                <ModalHeader className="modal-head">Add Category</ModalHeader>
                <ModalBody className="modal-body">
                    <Label>Category Name</Label>
                    <Input
                        placeholder="Category Name"
                        value={newData.name}
                        onChange={(e) => setNewData({ name: e.target.value })}
                    />
                </ModalBody>
                <ModalFooter className="modal-footer">
                    <Button disabled={loading} color="secondary" onClick={() => setModalCategory(false)}>Close</Button>
                    {/* <Button color="success" onClick={addCategory}>Add</Button> */}
                    <Button color="primary" disabled={loading} onClick={addCategory} className="d-flex align-items-center justify-content-center gap-2">
                        {loading && (
                            <Spinner size="sm" color="light" />
                        )}
                        Add Category
                    </Button>
                </ModalFooter>
            </Modal>

            {/* SUB CATEGORY MODAL */}
            <Modal isOpen={modalSubCategory} toggle={() => setModalSubCategory(false)} centered className="custom-modal">
                <ModalHeader className="modal-head">Add Sub Category</ModalHeader>
                <ModalBody className="modal-body">
                    <Label>Select Category</Label>
                    <Select
                        classNamePrefix={'vertical'}
                        options={categories}
                        value={selectedCategory}
                        onChange={setSelectedCategory}
                        placeholder="Select Category"
                    />

                    <Label className="mt-3">Sub Category Name</Label>
                    <Input
                        placeholder="Sub Category Name"
                        value={newData.name}
                        onChange={(e) => setNewData({
                            name: e.target
                                .value
                        })}
                    />
                </ModalBody>
                <ModalFooter className="modal-footer">
                    <Button color="secondary" onClick={() => setModalSubCategory(false)}>Close</Button>
                    {/* <Button color="success" onClick={addSubCategory}>Add</Button> */}
                    <Button color="primary" disabled={loading} onClick={addSubCategory} className="d-flex align-items-center justify-content-center gap-2">
                        {loading && (
                            <Spinner size="sm" color="light" />
                        )}
                        Add SubCategory
                    </Button>
                </ModalFooter>
            </Modal>

            {/* CSV MODAL */}
            <Modal isOpen={modalCSV} toggle={() => setModalCSV(false)} centered className="custom-modal">
                <ModalHeader className="modal-head">Import CSV</ModalHeader>
                <ModalBody className="modal-body">
                    <Label>Select CSV File</Label>
                    <Input type="file" accept=".csv" onChange={handleCSVFile} />
                    {csvPreview.length > 0 && (
                        <pre className="mt-3 csv-preview-box">
                            {csvPreview.join("\n")}
                        </pre>
                    )}
                </ModalBody>
                <ModalFooter className="modal-footer">
                    <Button color="secondary" onClick={() => setModalCSV(false)}>Close</Button>
                    {/* <Button color="success" onClick={uploadCSV}>Upload</Button> */}
                    <Button color="primary" disabled={loading} onClick={uploadCSV} className="d-flex align-items-center justify-content-center gap-2">
                        {loading && (
                            <Spinner size="sm" color="light" />
                        )}
                        Import
                    </Button>
                </ModalFooter>
            </Modal>

            {/* UNIT MODAL */}
            <Modal isOpen={modalUnit} toggle={() => setModalUnit(false)} centered className="custom-modal">
                <ModalHeader className="modal-head">Add Unit</ModalHeader>
                <ModalBody className="modal-body">
                    <Label>Unit Name</Label>
                    <Input
                        placeholder="Enter Unit Name"
                        value={newData.name}
                        onChange={(e) => setNewData({ name: e.target.value })}
                    />
                </ModalBody>
                <ModalFooter className="modal-footer">
                    <Button color="secondary" onClick={() => setModalUnit(false)}>Close</Button>
                    {/* <Button color="success" onClick={addUnit} >Add</Button> */}
                    <Button color="primary" disabled={loading} onClick={addUnit} className="d-flex align-items-center justify-content-center gap-2">
                        {loading && (
                            <Spinner size="sm" color="light" />
                        )}
                        Add Unit
                    </Button>
                </ModalFooter>
            </Modal>

        </Container>
    );
};

export default AddItemCard;
